module.exports = __webpack_public_path__ + "static/img-2-desktop-5f54ae7afb46e15b46c57d55407979d6.jpg";